module.exports = __webpack_public_path__ + "img/icon_class3.20bb9338.png";